/**
 * Enmascara un nombre completo mostrando la primera mitad de las letras de cada
 * palabra y reemplazando el resto por asteriscos (ej. `"Anibal Royero"` →
 * `"Ani*** Roy***"`). Aplica por igual a nombres y apellidos.
 *
 * La cantidad de letras visibles por palabra es la mitad redondeada hacia
 * arriba (`ceil`), por lo que las palabras de longitud impar muestran una letra
 * de más (ej. `"Pedro"` → `"Ped**"`). Para invertir el criterio, cambiar
 * `Math.ceil` por `Math.floor`. Las palabras de una sola letra se devuelven sin
 * cambios.
 *
 * @param fullName - Nombre completo a enmascarar.
 * @returns El nombre con cada palabra parcialmente enmascarada, o cadena vacía si no hay valor.
 */
export function maskFullName(fullName: string): string {
  if (!fullName) return '';

  return fullName
    .trim()
    .split(/\s+/)
    .map((word) => {
      if (word.length <= 1) return word;

      const visibleCount = Math.ceil(word.length / 2);
      return word.slice(0, visibleCount) + '*'.repeat(word.length - visibleCount);
    })
    .join(' ');
}
